import Image from "next/image";
import React from "react";
import styled from "@emotion/styled";
import { useTranslations } from "next-intl";
import { Avatar } from "@mui/material";

function PowerBy() {
  const translation = useTranslations("footer.powerBy");

  return (
    <PowerByContainer>
      {/* <LogoRemax
        src="/icons/remax-rd.png"
        alt="Logo Remax"
        width={200}
        height={60}
      /> */}
      <Avatar
        src="/images/v2/logos/4.png"
        alt="Logo Re/max"
        sx={{ width: 200, height: 75, objectFit: "cover" }}
        variant="square"
      />
      <p style={{ paddingTop: "10px" }}>
        {translation("title", {
          year: new Date().getFullYear(),
        })}
      </p>
      <p>
        {translation.rich("subtitle", {
          link: (chunks) => (
            <a
              href="https://version.do/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {chunks}
            </a>
          ),
        })}
      </p>
    </PowerByContainer>
  );
}

export default PowerBy;

const PowerByContainer = styled.section`
  width: 100%;
  background-color: white;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 15px;
  align-items: center;
  text-align: center;
  p {
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 13px;
    display: block;
    color: var(--color-brand-grey-main);
  }
  a {
    color: var(--color-brand-version);
  }
`;

const LogoRemax = styled(Image)`
  padding-bottom: 10px;
`;
